import StepWizard from 'react-step-wizard';
import { useEffect, useState } from 'react';
import Step1 from '../components/Step1';
import Step2 from '../components/Step2';
import { ROUTER } from './../../../../../constants/router';
import { BackTop, Button, Form, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import TemplateDesignService from '../../../../../services/TemplateDesign.service';
import Preview from './Preview';
import ModalConfirm from '../../../../../components/Shared/modal/confirm';
import useNotify from '../../../../../context/Notification/useNotify';
import { useNavigate, useParams } from 'react-router-dom';
import ModalDiscardChanges from '../../../../../components/Shared/modal/discardChanges';
import { useBlocker } from '../../../../../util/usePrompt';
import moment from 'moment';

export const getNextVersion = (version) => {
    let item = '';
    for (let index = 0; index <= 3; index++) {
        if (version?.split('.')[0][index] !== '0') {
            item = version
                ?.split('.')[0]
                ?.slice(index, version?.split('.')[0]?.length);
            break;
        }
    }
    item = String(Number(item) + 1);
    switch (item?.length) {
        case 1:
            item = '000'.concat(`${item}.0`);
            break;
        case 2:
            item = '00'.concat(`${item}.0`);
            break;
        case 3:
            item = '0'.concat(`${item}.0`);
            break;
        default:
            item = item.concat(`.0`);
            break;
    }
    return item;
};

const Steps = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const notify = useNotify();
    const { key } = useParams();
    // const [instance, setInstance] = useState();

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [isChangeLocation, setIsChangeLocation] = useState();
    const [nextLocation, setNextLocation] = useState();

    const [currentSelectList, setCurrentSelectList] = useState(1);
    const [currentProgress, setCurrentProgress] = useState(50);
    const [templateDetail, setTemplateDetail] = useState();
    const [consentGroupList, setConsentGroupList] = useState();
    const [publishData, setPublishData] = useState();
    const [previewValue, setPreviewValue] = useState();
    const [consent, setConsent] = useState();
    const [imageId, setImage] = useState();
    const [selectDocLayout, setSelectDocLayout] = useState();
    const [openConfirm, setOpenConfirm] = useState(false);

    const [openPublish, setOpenPublish] = useState(false);

    const [form] = Form.useForm();
    const calProgress = (number) => {
        setCurrentProgress(number);
    };

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };
    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onFinish = async () => {
        const exDate = previewValue?.effectiveDate?.format(
            'YYYY-MM-DDT00:00:00.000'
        );
        const payload = {
            ...previewValue,
            effectiveDate: new Date(exDate)?.toISOString(),
            showAcknowledgeButton: selectDocLayout === 1 ? false : true,
            logoId: imageId || null,
        };

        if (openPublish) {
            const payloadSave = {
                ...payload,
                isPublish: true,
            };
            if (key) {
                payloadSave['templateKey'] = key;
            }
            setPublishData(payloadSave);
            setOpenConfirm(true);
        } else {
            const payloadSave = {
                ...payload,
                isPublish: false,
            };
            if (key) {
                payloadSave['templateKey'] = key;
            }
            try {
                if (key) {
                    const { data } =
                        await TemplateDesignService.editTemplateTermAndCondition(
                            payloadSave
                        );
                    if (data?.resultMsg === 'SUCCESS') {
                        setChange(false);

                        notify({
                            title: t('common.Success'),
                            description: t('Successfully save data'),
                            timeOut: 1800,
                        });
                        setTimeout(() => {
                            navigate(ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN);
                        }, 1900);
                    } else {
                        setOpenConfirm(false);

                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to submit data'),
                        });
                    }
                } else {
                    const { data } =
                        await TemplateDesignService.addTemplateTermAndCondition(
                            payloadSave
                        );
                    if (data?.resultMsg === 'SUCCESS') {
                        setChange(false);
                        setOpenConfirm(false);

                        notify({
                            title: t('common.Success'),
                            description: t('Successfully saved data'),
                            timeOut: 1800,
                        });
                        setTimeout(() => {
                            navigate(ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN);
                        }, 1900);
                    } else {
                        setOpenConfirm(false);

                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to submit data'),
                        });
                    }
                }
            } catch (error) {}
        }
    };

    const getConsentGroup = async () => {
        try {
            const { data } = await TemplateDesignService.getConsentPublished({
                consentType: 'TermCondition',
            });
            const item = await data?.resultData;
            await setConsentGroupList(item);
        } catch (error) {}
    };

    const setConsentGroup = async (id) => {
        try {
            const { data } = await TemplateDesignService.getConsentPublished({
                consentType: 'TermCondition',
            });
            const item = await data?.resultData;
            setConsentGroupList(item);
            setConsent(item?.find((res) => id === res?.consentTxnGroupId));
        } catch (error) {}
    };

    const _getTagStatus = (item) => {
        switch (item?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {item?.status} {item?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {item?.status} {item?.latestPublishedVersion}
                    </Tag>
                );
            default:
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        Draft 0000.0
                    </Tag>
                );
        }
    };

    const getMasterTemplateDesign = async () => {
        try {
            const payload = {
                consentType: 'TermCondition',
            };
            const { data } =
                await TemplateDesignService.getMasterTemplateDesign(payload);
            if (data.resultData) {
                const item = data.resultData;
                form.setFieldsValue({
                    templateNameEn: item?.templateNameEn,
                    templateNameTh: item?.templateNameTh,
                    titleEn: item?.titleEn,
                    titleTh: item?.titleTh,
                    effectiveDate: moment(new Date()),
                });
                setChange(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getTemplateDetail = async (key) => {
        try {
            const { data } =
                await TemplateDesignService.getTemplateTermAndCondition(key);
            const item = data?.resultData;
            setConsentGroup(item?.consentTxnGroupId);
            const initial = {
                titleTh: item?.titleTh,
                titleEn: item?.titleEn,
                templateNameTh: item?.templateNameTh,
                templateNameEn: item?.templateNameEn,
                logoId: item?.logoId,
                showAcknowledgeButton: item?.showAcknowledgeButton,
                consentTxnGroupId: item?.consentTxnGroupId,
                effectiveDate: moment(item?.effectiveDate),
            };
            form?.setFieldsValue(initial);
            setPreviewValue(initial);
            setSelectDocLayout(item?.showAcknowledgeButton ? 2 : 1);
            setTemplateDetail(item);
            setChange(false);
        } catch (error) {}
    };

    useEffect(() => {
        if (key) {
            getTemplateDetail(key);
        } else {
            getMasterTemplateDesign();
            getConsentGroup();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={(_, allValue) => {
                    if (_) {
                        setChange(true);
                    }
                    const item = allValue;
                    setPreviewValue({ ...previewValue, ...item });
                }}
                onFinish={onFinish}
                form={form}
                layout="vertical"
            >
                <div className="grid grid-cols-8 gap-4 pt-5">
                    <div className="col-span-3">
                        <div className="bg-white rounded-md p-5  overflow-hidden">
                            <StepWizard
                                // instance={setInstance}
                                isLazyMount={true}
                                initialStep={currentSelectList}
                                currentStep={currentSelectList}
                                onStepChange={(stats) =>
                                    setCurrentSelectList(stats.activeStep)
                                }
                            >
                                <Step1
                                    selectDocLayout={selectDocLayout}
                                    setSelectDocLayout={setSelectDocLayout}
                                    setImage={setImage}
                                    setPreviewValue={setPreviewValue}
                                    currentProgress={currentProgress}
                                    form={form}
                                    calProgress={calProgress}
                                />
                                <Step2
                                    currentProgress={currentProgress}
                                    form={form}
                                    consentGroupList={consentGroupList}
                                    calProgress={calProgress}
                                    setConsent={setConsent}
                                />
                            </StepWizard>
                        </div>
                    </div>
                    <div className="col-span-5 space-y-4">
                        <div className="bg-white rounded-md p-5">
                            <div className="flex justify-between items-center">
                                <div className="flex-col">
                                    <div className="flex items-center gap-2">
                                        <div className="text-2xl font-semibold">
                                            {key
                                                ? t(
                                                      'Consent.EditTemplateDesign'
                                                  )
                                                : t(
                                                      'Consent.AddTemplateDesign'
                                                  )}
                                        </div>
                                        <div>
                                            {_getTagStatus(templateDetail)}
                                        </div>
                                    </div>
                                    <div
                                        hidden={
                                            templateDetail?.status !==
                                            'Published'
                                        }
                                        className="text-xs text-[#65707A]"
                                    >
                                        {t('Consent.PublishedDate')} :{' '}
                                        {templateDetail?.latestPublishedDate}
                                    </div>
                                </div>

                                <div
                                    className="flex items-center gap-2"
                                    hidden={currentSelectList === 1}
                                >
                                    <Button
                                        hidden={
                                            templateDetail?.status ===
                                            'Published'
                                        }
                                        key={'save'}
                                        size="large"
                                        // loading={loadingSave}
                                        type="primary"
                                        className="w-[140px] text-tiny"
                                        htmlType="submit"
                                        ghost
                                        onClick={() => {
                                            setOpenPublish(false);
                                        }}
                                    >
                                        {t('Consent.Save')}
                                    </Button>
                                    <Button
                                        key={'published'}
                                        size="large"
                                        type="primary"
                                        // loading={loadingSave}
                                        className="w-[140px] text-tiny"
                                        htmlType="submit"
                                        onClick={() => {
                                            // onFinish();
                                            setOpenPublish(true);
                                        }}
                                    >
                                        {t('Consent.Save&Publish')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <Preview
                            templateDetail={templateDetail}
                            currentSelectList={currentSelectList}
                            selectDocLayout={selectDocLayout}
                            consent={consent}
                            imageId={imageId}
                            value={previewValue}
                        />
                    </div>
                </div>
            </Form>
            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                handelOk={async () => {
                    try {
                        if (key) {
                            const { data } =
                                await TemplateDesignService.editTemplateTermAndCondition(
                                    publishData
                                );
                            if (data?.resultMsg === 'SUCCESS') {
                                setChange(false);
                                setOpenConfirm(false);

                                notify({
                                    title: t('common.Success'),
                                    description: t('Successfully saved data'),
                                    timeOut: 1800,
                                });
                                setTimeout(() => {
                                    navigate(
                                        ROUTER.CONSENT_MANAGEMENT
                                            .TEMPLATE_DESIGN
                                    );
                                }, 1900);
                            } else {
                                setOpenConfirm(false);

                                notify({
                                    type: 'error',
                                    title: t('common.Fail'),
                                    description: t('Failed to submit data'),
                                });
                            }
                        } else {
                            const { data } =
                                await TemplateDesignService.addTemplateTermAndCondition(
                                    publishData
                                );
                            if (data?.resultMsg === 'SUCCESS') {
                                setChange(false);
                                setOpenConfirm(false);

                                notify({
                                    title: t('common.Success'),
                                    description: t('Successfully saved data'),
                                    timeOut: 1800,
                                });
                                setTimeout(() => {
                                    navigate(
                                        ROUTER.CONSENT_MANAGEMENT
                                            .TEMPLATE_DESIGN
                                    );
                                }, 1900);
                            } else {
                                setOpenConfirm(false);

                                notify({
                                    type: 'error',
                                    title: t('common.Fail'),
                                    description: t('Failed to submit data'),
                                });
                            }
                        }
                    } catch (error) {}
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Consent.Published')}&nbsp;{'Template'} ?
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {templateDetail?.latestPublishedVersion
                                ? getNextVersion(
                                      templateDetail?.latestPublishedVersion
                                  )
                                : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </>
    );
};

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

export default Steps;
